export interface StatusDisplayProps {
  status: string;
  children?: React.ReactNode;
}

export const StatusContainer = ({ status, children }: StatusDisplayProps) => {
  const getWidth = () => {
    switch (status) {
      case 'not_started':
        return 'md:w-32';
      default:
        return 'md:w-[84px]';
    }
  };

  return (
    <div
      className={`flex h-[53px] flex-col items-center justify-center gap-1 rounded-lg ${getWidth()} md:px-3`}
    >
      {children}
    </div>
  );
};
